import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { SITE_SURVEYS_GROUPED_CRUD_ACTION_CREATORS } from '../actions/site_surveys_grouped_actions';
import FetchUtils, { parseJSON } from './fetch_utils';
import { SITE_SURVEYS_LOCATIONANDWALKTHROUGH_CRUD_ACTION_CREATORS } from '../actions/site_surveys_locationandwalkthrough_actions';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';

const fetchUtils = new FetchUtils();

export const siteSurveysGroupedRestCrudThunksForBuyer = new RestCrudThunks(
	'site_surveys/grouped/title',
	'site_survey',
	'siteSurvey',
	'siteSurveys',
	SITE_SURVEYS_GROUPED_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'site_survey/'
);

export const siteSurveysGroupedRestCrudThunksForSupplier = new RestCrudThunks(
	'site_surveys/grouped/title',
	'site_survey',
	'siteSurvey',
	'siteSurveys',
	SITE_SURVEYS_GROUPED_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'site_survey/'
);

export const siteSurveysLocationAndWalkthroughDetail = (roleType) => ({
	read: (
		params,
		targetCollectionName = null,
		pagination = null,
		sorting = null,
		filters = null,
		addToTargetCollection = false
	) => {
		if (pagination) {
			const paginationQuery = {
				offset: (pagination.current - 1) * pagination.pageSize,
				limit: pagination.pageSize,
			};
			params = {
				...params,
				...paginationQuery,
			};
		}

		// if sorting present, fix order naming and add to query params
		if (sorting) {
			const sortingQuery = { ...sorting, order: sorting.order === 'ascend' ? 'asc' : 'desc' };
			params = {
				...params,
				...sortingQuery,
			};
		}
		if (filters) {
			params = {
				...params,
				...filters,
			};
		}

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(
					SITE_SURVEYS_LOCATIONANDWALKTHROUGH_CRUD_ACTION_CREATORS.fetchStart(targetCollectionName)
				);

				fetchUtils
					.get(
						getBackendUri() +
							`/api/v1/${roleType}/site_survey/site_surveys/grouped/title/${filters.title}/template/${filters.templateId}`,
						Object.assign(
							{ headers: { Accept: 'application/json', 'Content-Type': 'application/json' } },
							params
						)
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(
								SITE_SURVEYS_LOCATIONANDWALKTHROUGH_CRUD_ACTION_CREATORS.fetchError(
									d.message,
									targetCollectionName
								)
							);
							reject(d.message);
						} else {
							dispatch(
								SITE_SURVEYS_LOCATIONANDWALKTHROUGH_CRUD_ACTION_CREATORS.fetchSuccess(
									d.data,
									d.count,
									targetCollectionName,
									{
										...pagination,
										total: d.count,
									},
									sorting,
									filters,
									addToTargetCollection
								)
							);
							resolve(d.data);
						}
					})
					.catch((d) => {
						if (d.isCancelled) {
							console.log(`Cancelled Promise....${targetCollectionName}`);
						} else {
							dispatch(
								SITE_SURVEYS_LOCATIONANDWALKTHROUGH_CRUD_ACTION_CREATORS.fetchError(
									d.message,
									targetCollectionName
								)
							);
							reject(d.message);
						}
					});
			});
		};
	},
});
